export type RetentionSettingsPayload = {
	id: number;
	name: string;
	audioRetentionDays: number;
	beneficiaryRetentionMonths: number;
};

export type RetentionSettingsFetchedAction = {
	type: 'RETENTION_SETTINGS_FETCHED';
	payload: RetentionSettingsPayload;
};

export default (payload: RetentionSettingsPayload): RetentionSettingsFetchedAction => ({
	type: 'RETENTION_SETTINGS_FETCHED',
	payload,
});
